// extracted by mini-css-extract-plugin
module.exports = {"root":"Member_root__2euQE","statusLabel":"Member_statusLabel__2tU9q"};